/**
 * Mappa ID ristorante → namespace originale (cluster).
 * Usata per mantenere i controlli di analytics e assets
 * senza dover mantenere un bucket separato per ogni namespace.
 *
 * Fonte: "Disattivazione Campari 2026 - Porta Avanti Campari.csv"
 *
 * Note:
 *   - 24696 AURORA BEACH  → Contratto MyCIA con dominio
 *   - 24790 MOOD          → Contratto MyCIA con dominio
 */
const restaurantNamespaceMap = {
    13045: "aperolspritz",  // LE PETIT PARMA BAR E COMPANATICO 5GPoZEP0E
    6788: "campari",       // BAR PASI
    7292: "wild",          // THE TRAVELLER
    6691: "aperolspritz",  // MACELLO PUBBLICO
    9248: "aperolspritz",  // CAFFE DEL MAR
    11032: "espolon",      // FRASETE
    14571: "aperolspritz", // PAPPAGALLO BEACH
    8565: "aperolspritz",  // NEL CANTON
    7011: "aperolspritz",  // LA TRADISION
    13652: "camparisoda",  // BAR CRISTALLO
    24443: "camparisoda",  // SPONTANEO
    6950: "aperolspritz",  // KOKONUTS
    7348: "campari",       // TRIDENTE
    15234: "camparisoda",  // VERDI BISTRO
    8434: "campari",       // FREEDOM
    23895: "aperolspritz", // LA MOTTA NEW
    7658: "wild",          // SHERLOCK HOLMES
    10155: "espolon",      // JUTA CAFE
    7059: "aperolspritz",  // MAXIM
    24696: "aperolspritz", // AURORA BEACH (Contratto MyCIA con dominio)
    24790: "crodinoxl",    // MOOD (Contratto MyCIA con dominio)
};

/**
 * Restituisce il namespace associato a un ID ristorante,
 * oppure il namespace di default (REACT_APP_NAMESPACE o "mycia").
 *
 * @param {number|string} restaurantId
 * @returns {string}
 */
export function getNamespaceForRestaurant(restaurantId) {
    return restaurantNamespaceMap[Number(restaurantId)]
        || process.env.REACT_APP_NAMESPACE
        || "mycia";
}
